import * as React from 'react';

const SvgNight = (props) => (
  <svg
    width={20}
    height={21}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.597 3.31c-.189.084-.444.217-.784.413a7.708 7.708 0 1 0 7.708 13.352c.34-.197.583-.352.75-.474-.152-.067-.338-.14-.569-.231l-.159-.063c-1.516-.599-4.084-1.685-5.86-4.762C7.905 8.468 8.248 5.7 8.487 4.087l.025-.169c.037-.245.067-.443.084-.607Zm.334-.112s-.006.002-.016.002l.016-.002Zm-.322-.234Zm7.97 13.803-.002-.002a.012.012 0 0 1 .002.002Zm-.053-.385a.06.06 0 0 1 .009-.013l-.01.013ZM9.725 4.27c-.23 1.544-.517 3.952 1.04 6.649 1.556 2.696 3.786 3.65 5.238 4.225l.15.059c.3.118.59.232.814.343.133.066.275.147.398.247.121.099.27.254.34.481.159.516-.194.908-.41 1.105-.258.234-.647.487-1.149.777A8.958 8.958 0 1 1 7.188 2.641c.502-.29.916-.5 1.247-.606.278-.089.794-.199 1.162.197.161.174.221.38.246.534.026.157.025.32.015.469-.015.25-.061.557-.11.876a80.53 80.53 0 0 0-.023.16Z'
      fill='#EEADBC'
    />
  </svg>
);

export default SvgNight;
